// Modules
import jwt_decode from 'jwt-decode'

// Application
import { LoginNav } from 'typings'

interface UserId {
    id: number
}

interface jwtTokenInterface {
    exp: number
    iat: number
    brand: string
    cip: string
    isInvalid: boolean
    type: string
}

export const getUserIdJwt = (token: string): number => {
    const decode = jwt_decode<UserId>(token)
    const { id } = decode

    return id
}

export const getUserJwt = (token: string): LoginNav | null => {
    const decode = jwt_decode<LoginNav>(token)
    return decode
}

export const isTokenExpired = (token: string): boolean => {
    const decode = jwt_decode<jwtTokenInterface>(token)
    return new Date().getTime() > new Date(decode.exp * 1000).getTime()
}

export const getTokenType = (token: string): string => {
    try {
        const decode = jwt_decode<jwtTokenInterface>(token)
        return decode.type
    } catch (e) {
        return ''
    }
}
